@use '../../styling/form-controls.scss' as *;

.Log {
  @extend %form-control-border;
  @extend %form-control-background;

  box-sizing: border-box;
  overflow: auto;
  height: 100%;
  margin: 0;
  font-size: smaller;

  &,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    padding: 0.5em;
  }
}
